export default __webpack_public_path__ + "static/media/object.c668fb32.png";